import {
  Page,
  PageHeader,
  PageHeaderTitle,
  PageBody,
  PageHeaderDescription,
  Link,
} from '@customerio/pluma-components/react';
import { PageTitle } from '@/components/page-title';
import { TasksTable } from '@/features/tasks';

export default function Tasks() {
  return (
    <>
      <PageTitle title="Tasks" />
      <Page w="full">
        <PageHeader>
          <PageHeaderTitle>Tasks</PageHeaderTitle>
          <PageHeaderDescription>
            Monitor background tasks, like segment creation and imports, across your workspace.{' '}
            <Link
              href="https://docs.customer.io/accounts-and-workspaces/workspace-tasks/"
              isExternal
              variant="secondary"
            >
              Learn more
            </Link>
          </PageHeaderDescription>
        </PageHeader>
        <PageBody>
          <TasksTable />
        </PageBody>
      </Page>
    </>
  );
}
